@for (item of $items(); track item; let i = $index) {
  <ng-container
    *ngTemplateOutlet="
      template();
      context: {
        $implicit: item,
        onDelete: removeItem.bind(this),
      }
    "
  ></ng-container>
}

@if (!canHideInfiniteScroll()) {
  <div style="height: 20px; width: 100%" class="infinite-scroll" #infiniteScroll></div>
}

@if (isLoading()) {
  <app-community-loader />
}
